import { render, staticRenderFns } from "./show.vue?vue&type=template&id=ed93c1f4&lang=pug&"
import script from "./show.vue?vue&type=script&setup=true&lang=js&"
export * from "./show.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./show.vue?vue&type=style&index=0&id=ed93c1f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports